// extracted by mini-css-extract-plugin
module.exports = {"container":"business-module--container--3iKq2"};